import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    confirm: 'Duplicate and edit',
    description:
      'You cannot edit an invoice that has already been sent. To edit an invoice, you must duplicate it, your initial invoice will then be marked as "canceled".',
    title: 'Duplicate your invoice to edit it',
  },
  fr: {
    cancel: 'Annuler',
    confirm: 'Dupliquer et modifier',
    description:
      'Vous ne pouvez pas modifier une facture déjà envoyée. Pour éditer une facture, vous devez la dupliquer, votre facture initiale sera alors marquée comme “annulée”.',
    title: 'Dupliquez votre facture pour la modifier',
  },
} as const);
